import { SERVICES } from '../../utils/constants';
import { PROJECT_TYPES, SYSTEM_CREATION_TYPES } from './constants';

export const isResidential = type => type === PROJECT_TYPES.RESIDENTIAL;

export const isCommercial = type => type === PROJECT_TYPES.COMMERCIAL;

export const isExisting = type => type === SYSTEM_CREATION_TYPES.EXISTING;

export const isNew = type => type === SYSTEM_CREATION_TYPES.NEW;

export const isNA = type => type === SYSTEM_CREATION_TYPES.NA;

export const isDRSService = service => service === SERVICES.DRS;

export const isPermitService = service => service === SERVICES.PERMIT;
